import React, { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'

import StepForm from '../../../../../../../features/components/Forms/StepForm'
import ClickThroughLinkStep from '../../Steps/ClickThroughLinkStep'
import FileUploadStep from '../../Steps/FileUploadStep'
import StatusStep from '../../Steps/StatusStep'

import { usePurifiedFormik } from '../../../../../../../hooks/formHooks/usePurifiedFormik'
import { transformValuesToBE } from './formatters'
import { useSubmitDv360CreateAdsBatch, useSubmitDv360CreateAdsParams } from '../../hooks'
import useIsInternalAdCreation from '../../../../../../../features/hooks/internalAdHooks/useIsInternalAdCreation'

import { getInitialValues } from './fields'
import { validationSchema } from './validation'

const CreativeFileUploadRoute = ({ FormRouteSelector, lineItemType, ...formProps }) => {
  const createAdsParams = useSubmitDv360CreateAdsParams()
  const submitDv360CreateAdsBatch = useSubmitDv360CreateAdsBatch()
  const isInternalAdCreation = useIsInternalAdCreation()

  const onSubmit = useCallback(
    values => {
      const formattedData = transformValuesToBE({
        values,
        lineItemType,
        ...createAdsParams
      })

      submitDv360CreateAdsBatch(formattedData, values)
    },
    [submitDv360CreateAdsBatch, lineItemType, createAdsParams]
  )

  const initialValues = useMemo(() => getInitialValues(isInternalAdCreation), [isInternalAdCreation])

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  const steps = useMemo(
    () => [
      {
        component: FormRouteSelector,
        show: true
      },
      {
        component: <ClickThroughLinkStep />,
        show: true
      },
      {
        component: <FileUploadStep lineItemType={lineItemType} />,
        show: true
      },
      {
        component: <StatusStep />,
        show: true
      }
    ],
    [lineItemType, FormRouteSelector]
  )

  return <StepForm steps={steps} formik={purifiedFormik} {...formProps} />
}

export default CreativeFileUploadRoute
